import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {ImportExportComponent} from "@app/_components/_helpers/import-export/import-export.component";
import {User} from "@app/_models";
import {LazyLoadEvent, MessageService} from "primeng/api";
import {UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {AlertService, AuthenticationService, ConstantService} from "@app/_services";
import {ReservationService} from "@app/_components/reservation";
import {ActivatedRoute, Router} from "@angular/router";
import {PropertyService} from "@app/_components/property";
import {Location} from "@angular/common";
import {MAT_DIALOG_DATA, MatDialog, MatDialogConfig} from "@angular/material/dialog";
import * as moment from "moment";
import {first} from "rxjs/operators";
import {Table} from "primeng/table";
import {ReservationContainerComponent} from "@app/_components/reservation/components/reservation/reservation-container/reservation-container.component";
import {OrderComponent} from "@app/_components/order/order/order.component";
import {ReservationAdvanceSearchComponent} from "@app/_components/reservation/components/reservation-advance-search/reservation-advance-search.component";
import {ReservationCreateComponent} from "@app/_components/reservation/components/reservation-create/reservation-create.component";

@Component({
    selector: 'app-reservation-balance-due',
    templateUrl: './reservation-balance-due.component.html',
    styleUrls: ['./reservation-balance-due.component.css'],
    standalone: false
})
export class ReservationBalanceDueComponent implements OnInit {

  @ViewChild(ImportExportComponent) importExportComponent: ImportExportComponent;

  datasource: any[];
  reservation: User;
  reservations: any[] = [];
  recordTotal: number;
  lazyLoadEvent: LazyLoadEvent;
  loading = true;
  multiSortMeta = [];
  advanceSearchData: any = [];
  advanceSearchDataFilter: LazyLoadEvent = {};
  eventFilter: LazyLoadEvent = {};

  //For reservation list to be shown on dialog
  formTitle: String;
  reservationForPredicate: any;
  showCreateReservationPopUp = false;

  // forms
  form1: UntypedFormGroup;
  formLoading = false;
  formAlert: String;

  statuses: any;

  validationMessages = {
    shortTermRentalId: [{ type: 'required', message: 'Required' }],
    emailAddress: [{ type: 'required', message: 'Required' },
      { type: 'email', message: 'Not a valid Email' }],
    referralSourceId: [{ type: 'required', message: 'Required' }],
    numAdults: [{ type: 'required', message: 'Required' }],
    numChildren: [{ type: 'required', message: 'Required' }],
    checkOutDate: [{ type: 'required', message: 'Required' }],
    checkInDate: [{ type: 'required', message: 'Required' }],
    firstName: [{ type: 'required', message: 'Required' }],
    lastName: [{ type: 'required', message: 'Required' }],
  };
  referralSources: any[];
  properties: any[] = [];
  numAdults: any[];
  searchName: any;
  searchData: { [k: string]: any; };
  activatedRoutePropertyCode: any;



  constructor(
    public authenticationService: AuthenticationService,
    public reservationService: ReservationService,
    public alertService: AlertService,
    public constantService: ConstantService,
    private messageService: MessageService,
    private formBuilder: UntypedFormBuilder,
    public router: Router,
    private _activatedRoute: ActivatedRoute,
    private propertyService: PropertyService,
    private location1: Location,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.formTitle = data.title,
      this.reservationForPredicate = data.reservation;
    this.referralSources = this.reservationService.referralSources;
    this.numAdults = this.reservationService.numAdults;
    if(this._activatedRoute.snapshot.paramMap.get('propertyCode'))
    {
      this.activatedRoutePropertyCode = this._activatedRoute.snapshot.paramMap.get('propertyCode');
    }
  }


  ngOnInit() {
    this._activatedRoute.queryParams.subscribe(params => {
      this.searchData = params['searchName'];
    });
    if(this.searchData != null && this.searchData != undefined){
      this.searchName = this.searchData;
    }
    this.formBuild();
    this.fetchProperties();
  }

  fetchProperties() {
    try {
      this.propertyService.findAllSummaryWithStatusActiveAndSuspended()
        .subscribe(
          res => {
            // console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
            this.properties = res.data.properties;
          },
          err => {
            console.log('Feature-Update FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => { });
    } catch (error) {
      console.log('Form Invalid: ' + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  formBuild() {
    this.form1 = this.formBuilder.group({
      shortTermRentalId: ['', Validators.required],
      referralSourceId: ['', Validators.required],
      numAdults: ['', Validators.required],
      numChildren: ['', Validators.required],
      checkOutDate: ['', Validators.required],
      checkInDate: ['', Validators.required],
      guestProfile: this.formBuilder.group({
        firstName: ['', Validators.required],
        lastName: ['', Validators.required],
        emailAddress: ['', Validators.compose([Validators.required, Validators.email])],
        guestCompanions: new UntypedFormArray([]),
      }),
    });
  }




  loadLazy(event: LazyLoadEvent) {
    try {
      console.log(this.advanceSearchDataFilter)
      if(event.filters && Object.keys(event.filters).length > 0)
      {
        this.eventFilter = event.filters;
      }
      if(this.advanceSearchDataFilter.filters && Object.keys(this.advanceSearchDataFilter.filters).length > 0)
      {
        //combine objects
        event.filters = { ...this.advanceSearchDataFilter.filters, ...event.filters };
      }
      this.loading = true;
      this.lazyLoadEvent = event;
      console.log('EVENT ' + JSON.stringify(event));
      console.log(

        ' event.first:' + event.first
        + '  |  event.rows:' + event.rows
        + '  |  event.sortField:' + event.sortField
        + '  |  event.sortOrder:' + event.sortOrder
        + '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
        + '  |  event.globalFilter:' + event.globalFilter
        + '  |  event.filters:' + JSON.stringify(event.filters)
      );
      // https://stackoverflow.com/questions/679915/how-do-i-test-for-an-empty-javascript-object
      // if we are filtering by some field (ie property) (event.filters are not empty {})
      if (Object.keys(event.filters).length > 0) {
        console.log('FILTERS!')
        // if there are no other sorts, initialize the event.multiSortMeta
        if (!event.multiSortMeta) {
          event.multiSortMeta = [];
        }
        // sort by checkInDateTime
        event.multiSortMeta.push({ field: 'checkInDateTime', order: -1 });
      }
      else {
        // sort by createDate
        console.log('NO MULTI!')
        if (!event.multiSortMeta) {
          event.multiSortMeta = [];
        }
        event.multiSortMeta.push({ field: 'createDate', order: -1 });
      }




      //Show only predicate reservation list if it's not null. Used for future occupancy
      if (this.reservationForPredicate != null && this.reservationForPredicate.shortTermRentalId != null) {
        let reservationFilter = { 'shortTermRentalVO.shortTermRentalId': { 'value': this.reservationForPredicate.shortTermRentalId, 'matchMode': 'in' } };
        Object.assign(event.filters, reservationFilter);
        event.multiSortMeta = [];
        event.multiSortMeta.push({ field: 'checkInDateTime', order: -1 });
      }

      if (event.filters?.checkInDateTime) {
        event.filters.checkInDateTime.value = moment(event.filters.checkInDateTime.value).format('MM/DD/YYYY');
      }

      if (event.filters?.checkOutDateTime) {
        event.filters.checkOutDateTime.value = moment(event.filters.checkOutDateTime.value).format('MM/DD/YYYY');
      }


      if(this.activatedRoutePropertyCode)
      {
        // show only activities that are assigned to this activityFeeId
        let rateBucketIdFilter = { 'shortTermRentalVO.propertyCode': { 'value': this.activatedRoutePropertyCode, 'matchMode': 'in' } };
        Object.assign(event.filters, rateBucketIdFilter);
      }
      if (event.filters?.global) {
        event.filters.global.value = event.filters.global.value.trim();
        this.searchName = event.filters.global.value.trim();
      }
      if (event.globalFilter == null && this.searchName != null && this.searchName != "") {
        event.filters.global = {
          matchMode:"contains",
          value:this.searchName
        }
        event.globalFilter = this.searchName;
      }
      const pageNumber = Math.round(event.first / event.rows);
      this.reservationService.findByAgentListFilterBalanceDue(
        pageNumber, event.rows,
        event.sortField,
        event.sortOrder,
        event.multiSortMeta,
        event.globalFilter,
        event.filters).pipe(first()).subscribe(

        res => {
          // console.log('reservations are: ' + JSON.stringify(apiResponse));
          this.datasource = res.data.reservations;
          this.recordTotal = res.page.recordTotal;
          this.reservations = res.data.reservations;
         // this.location1.go('/reservations');
        },
        error => {
          console.log('USER LIST!: ' + JSON.stringify(error));
          this.alertService.error(error);
          this.loading = false;
        },
        () => { this.loading = false; }
      );

      if (this.datasource) {
        this.reservations = this.datasource.slice(event.first, (event.first + event.rows));
      }
    } catch (error) {
      console.log('loadLazy(' + event + ')' + error);
    }
  }
  onRowSelect(event) {
    try {
      // use this for adding query params
      // this.router.navigate(['reservation-edit'], { queryParams: { reservationId: event.data.reservationId } });
      // this.router.navigate(['reservations', event.data.reservationId]);
      this.onOpenFormEdit(event.data);
    } catch (error) {
      console.log('onRowSelect(' + event + ')' + error);
    }
  }

  getResStatusName(resStatus) {
    if(resStatus != null && resStatus != undefined && resStatus != ""){
      return this.constantService.reservationStatuses.find(function(item) { return item.value === resStatus }).label;
    }else{
      return "";
    }
  }

  getResStatusColor(resStatus) {
    if(resStatus != null && resStatus != undefined && resStatus != ""){
      return this.constantService.reservationStatuses.find(function(item) { return item.value === resStatus }).color;
    }else{
      return "";
    }

  }
  clear(table: Table) {
    table.clear();
  }

  reloadPage() {
    window.location.reload();
  }

  /*********
   * Add New Button
   *
   */
  onOpenFormAdd() {

    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;

    dialogConfig.maxWidth = "100vw";
    dialogConfig.width = "95vw";
    dialogConfig.maxHeight = "50vw";
    dialogConfig.height = "95vh";

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      title: 'Add Reservation'
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(ReservationContainerComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
    // dialogRef.componentInstance.doAdd.subscribe(
    // 	data => {
    // 		console.log('Dialog output:', data);

    // 		// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
    // 		this.addReservationCB(data);

    // 		// close the dialogBox
    // 		dialogRef.close();
    // 	});
  }


  /*********
   * Edit Button
   *
   */
  // onOpenFormEdit(reservation: any) {

  // 	const dialogConfig = new MatDialogConfig();

  // 	// settings
  // 	dialogConfig.disableClose = false;
  // 	dialogConfig.autoFocus = true;
  // 	dialogConfig.hasBackdrop = true;
  //   dialogConfig.maxWidth = "100vw";
  // 		dialogConfig.width = "95vw";
  //     dialogConfig.maxHeight = "50vw";
  // 		dialogConfig.height = "95vh";

  // 	// pass data, ie rateBuicket: this.shortTermRentalId,
  // 	dialogConfig.data = {
  // 		reservationId: reservation.reservationId,
  //     reservation: reservation,
  //     showCloseButton: true,
  // 		title: 'Edit Order'
  // 	};

  // 	// open the popup and get a reference to it called dialogRef
  // 	const dialogRef = this.dialog.open(ReservationContainerComponent, dialogConfig);
  //   this.location1.go('/reservations-edit/' + reservation.reservationId);

  // 	// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
  // 	// dialogRef.componentInstance.doUpdate.subscribe(
  // 	// 	data => {
  // 	// 		console.log('Dialog output:', data);

  // 	// 		// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
  // 	// 		this.updateReservationCB(data);

  // 	// 		// close the dialogBox
  // 	// 		dialogRef.close();
  // 	// 	});

  // 	// dialogRef.componentInstance.doDelete.subscribe(
  // 	// 	data => {
  // 	// 		console.log('Dialog output:', data);

  // 	// 		// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
  // 	// 		this.deleteReservationCB(data);

  // 	// 		// close the dialogBox
  // 	// 		dialogRef.close();
  // 	// 	});
  // }

  /*********
   * Edit Button
   *
   */
  onOpenFormEdit(reservation: any) {

    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.maxWidth = "100vw";
    dialogConfig.width = "95vw";
    dialogConfig.maxHeight = "50vw";
    dialogConfig.height = "95vh";
    dialogConfig.panelClass = "edit-order-mobile";

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      reservationId: reservation.reservationId,
      reservation: reservation,
      showCloseButton: true,
      title: 'Edit Order'
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(OrderComponent, dialogConfig);
    // this.location1.go('/reservations-edit/' + reservation.reservationId);
    this.location1.go('/order/' + reservation.orderId);

    // to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
    dialogRef.componentInstance.doUpdate.subscribe(
      data => {
        console.log('Dialog output:', data);
        this.searchName = data;

        // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
        // this.updateReservationCB(data);
        this.loadLazy(this.lazyLoadEvent);

        // close the dialogBox
        dialogRef.close();
      });

    // dialogRef.componentInstance.doDelete.subscribe(
    // 	data => {
    // 		console.log('Dialog output:', data);

    // 		// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
    // 		this.deleteReservationCB(data);

    // 		// close the dialogBox
    // 		dialogRef.close();
    // 	});
  }

  /**
   *
   * Dialog from Form Callbacks
   * To edit the list show add/edit/delete in real time from the popup form
   *
   */
  addReservationCB(reservation: any) {
    console.log('Adding Reservation: ' + JSON.stringify(reservation));
    // if we don't have a tests array yet...
    if (!this.reservations) {
      this.reservations = [];
    }
    // unshift adds to the front of the array (), push adds to the back
    this.reservations.unshift(reservation);

    // no idea what this is but it is required to update the array
    this.reservations = [...this.reservations];

    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Reservation ' + reservation.reservationId + ' Added', life: 3000 });
  }

  updateReservationCB(reservation: any) {
    console.log('Updating Reservation: ' + JSON.stringify(reservation));
    let itemIndex = this.reservations.findIndex((item: any) => item.reservationId === reservation.reservationId);
    this.reservations[itemIndex] = reservation;

    // no idea what this is but it is required to update the array
    this.reservations = [...this.reservations];

    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Reservation ' + reservation.reservationId + ' Updated', life: 3000 });
  }

  deleteReservationCB(reservation: any) {
    console.log('Removing Reservation: ' + reservation);
    this.reservations.splice(this.reservations.indexOf(reservation), 1);
    this.recordTotal = this.reservations.length;

    // no idea what this is but it is required to update the array
    this.reservations = [...this.reservations];

    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Reservation ' + reservation.reservationId + ' Deleted', life: 3000 });
  }

  onAdvanceSearch() {
    try {

      const dialogConfig = new MatDialogConfig();

      // settings
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = true;
      dialogConfig.hasBackdrop = true;
      dialogConfig.maxWidth = "45vw";
      dialogConfig.width = "40vw";
      // dialogConfig.height = "45vw";
      // dialogConfig.maxHeight = "60vw";

      // pass data, ie rateBuicket: this.shortTermRentalId,
      dialogConfig.data = {
        advanceSearchData: this.advanceSearchData,
        title: 'Advance Search'
      };

      // open the popup and get a reference to it called dialogRef
      const dialogRef = this.dialog.open(ReservationAdvanceSearchComponent, dialogConfig);
      dialogRef.componentInstance.doSearchCB.subscribe(
        data => {
          this.advanceSearchData = data;
          let event = {"first":0,"rows":50,"sortOrder":1, "globalFilter":null,"multiSortMeta":[]};
          if(this.advanceSearchData)
          {
            this.advanceSearchDataFilter.filters = {};
            if(this.advanceSearchData.locationIds)
            {
              let locationIds = [];
              this.advanceSearchData.locationIds.forEach(element => {
                const id = element != null && typeof element === 'object' ? element.locationId : element;
                locationIds.push(id);
              });
              this.advanceSearchDataFilter.filters["shortTermRentalVO.locationId"] = {"value":locationIds,"matchMode":"in"}
            }
            if(this.advanceSearchData.shortTermRentalIds)
            {
              let shortTermRentalIds = [];
              this.advanceSearchData.shortTermRentalIds.forEach(element => {
                const id = element != null && typeof element === 'object' ? element.shortTermRentalId : element;
                shortTermRentalIds.push(id);
              });
              this.advanceSearchDataFilter.filters["shortTermRentalVO.shortTermRentalId"] = {"value":shortTermRentalIds,"matchMode":"in"}
            }
            if(this.advanceSearchData.arrivalStartDate)
            {
              this.advanceSearchDataFilter.filters["checkInDateStart"] = {"value":moment(this.advanceSearchData.arrivalStartDate).format('MM/DD/YYYY'),"matchMode":"in"}
            }
            if(this.advanceSearchData.arrivalEndDate)
            {
              this.advanceSearchDataFilter.filters["checkInDateEnd"] = {"value":moment(this.advanceSearchData.arrivalEndDate).format('MM/DD/YYYY'),"matchMode":"in"}
            }
            if(this.advanceSearchData.saleStartDate)
            {
              this.advanceSearchDataFilter.filters["saleDateStart"] = {"value":moment(this.advanceSearchData.saleStartDate).format('MM/DD/YYYY'),"matchMode":"in"}
            }
            if(this.advanceSearchData.saleEndDate)
            {
              this.advanceSearchDataFilter.filters["saleDateEnd"] = {"value":moment(this.advanceSearchData.saleEndDate).format('MM/DD/YYYY'),"matchMode":"in"}
            }
				if(this.advanceSearchData.checkoutStartDate)
				{
				  this.advanceSearchDataFilter.filters["checkOutDateStart"] = {"value":moment(this.advanceSearchData.checkoutStartDate).format('MM/DD/YYYY'),"matchMode":"in"}
				}
				if(this.advanceSearchData.checkoutEndDate)
				{
				  this.advanceSearchDataFilter.filters["checkOutDateEnd"] = {"value":moment(this.advanceSearchData.checkoutEndDate).format('MM/DD/YYYY'),"matchMode":"in"}
				}
				if(this.advanceSearchData.occupyingStartDate)
				{
				  this.advanceSearchDataFilter.filters["stayDateStart"] = {"value":moment(this.advanceSearchData.occupyingStartDate).format('MM/DD/YYYY'),"matchMode":"in"}
				}
				if(this.advanceSearchData.occupyingEndDate)
				{
				  this.advanceSearchDataFilter.filters["stayDateEnd"] = {"value":moment(this.advanceSearchData.occupyingEndDate).format('MM/DD/YYYY'),"matchMode":"in"}
				}
            if(this.advanceSearchData.reservationStatus)
            {
              this.advanceSearchDataFilter.filters["reservationStatus"] = {"value": this.advanceSearchData.reservationStatus,"matchMode":"in"}
            }
            if(this.advanceSearchData.reservationType)
            {
              this.advanceSearchDataFilter.filters["reservationType"] = {"value": this.advanceSearchData.reservationType,"matchMode":"in"}
            }
            if(this.advanceSearchData.lastName)
            {
              this.advanceSearchDataFilter.filters["guestProfileVO.lastName"] = {"value": this.advanceSearchData.lastName,"matchMode":"in"}
            }
            if(this.advanceSearchData.wildcardSearch)
            {
              this.advanceSearchDataFilter.filters["wildcardSearch"] = {"value": this.advanceSearchData.wildcardSearch,"matchMode":"in"}
            }
          }
          if(this.eventFilter && Object.keys(this.eventFilter).length > 0)
          {
            //combine objects
            this.eventFilter = { ...this.eventFilter, ...this.advanceSearchDataFilter.filters};
            event['filters'] = this.eventFilter;
          }
          this.loadLazy(event);
          // close the dialogBox
          dialogRef.close();
        });
    } catch (error) {
      console.log('onRowSelect(' + this.advanceSearchDataFilter + ')' + error);
    }
  }

  openCreateReservationPopUp() {
    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.maxWidth = "40vw";
    dialogConfig.width = "20vw";
    dialogConfig.disableClose = true;
    dialogConfig.panelClass = "create-reservation-popup";
    // dialogConfig.maxHeight = "50vw";
    // dialogConfig.height = "95vh";

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      showCloseButton: true,
      openNewTab: true
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(ReservationCreateComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
    dialogRef.componentInstance.doUpdate.subscribe(
      data => {
        console.log('Dialog output:', data);

        // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
        this.loadLazy(this.lazyLoadEvent);

        // close the dialogBox
        dialogRef.close();
      });
  }

  openHelpAlert() {
    this.alertService.success('If you need help or are experiencing any difficulties, please call Dipesh on Ring Central at extension 907.', true);
  }

  exportSelected(exporttype: any) {
    this.importExportComponent.exporData(exporttype, this.reservations, 'Reservations Info');
  }

  sendReservationBalanceDueEmail(reservation) {
  this.reservationService.sendReservationBalanceDueEmail(reservation.reservationId).subscribe(res => {

  });
}
  runAutoPayment(reservation) {
    this.reservationService.autoPayReservationBalance(reservation.reservationId).subscribe(res => {

    });
  }
}

